<script setup>
import { ref } from 'vue';
import { storeToRefs } from "pinia";
import VueResizable from 'vue-resizable'
import { CloseBold } from '@element-plus/icons-vue';
import { setToLocalStorage } from '../../stores/utils';
import { useFVStore } from '../../stores/formvibes';

const store = useFVStore();
const props = defineProps(['row','closeExpand']);
const handlers = ref([ 'lb', 'l', 'lt']);

const { generalStates, size } = storeToRefs(store);
const resizeStop = (e) => {
    const width = e.width;
    const height = e.height;
    if (Number(width) <= 400) {
        setToLocalStorage('fv-sidebar', {
            width: 400,
            height: width,
        });
    }
    else{
        setToLocalStorage('fv-sidebar', {
            width: width,
            height: height,
        });
    }

    generalStates.value.size = {
        width: width,
        height: height
    }
};

</script>
<template>
    <vue-resizable class="fv-side-panel" :width="size.width" :active="handlers" height="100%" style="position: fixed;left: unset;right: 0;z-index: 99999;cursor: unset;" @resize:end="resizeStop">
        <div class="resizable-content" >
            <div class="fv-expand-content-wrapper">
                <el-icon class="fv-cursor" size="20" @click="closeExpand"><CloseBold /></el-icon>
                <div class="fv-expand-content">
                    <dl>
                        <div class="fv-expand-row" v-for="(dt,key,index) in row" :key="index">
                            <dt>
                                {{key}}
                            </dt>
                            <dd>
                                <span>{{dt}}</span>
                            </dd>
                        </div>
                    </dl>
                </div>
            </div>
        </div>
    </vue-resizable> 
</template>